var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIftt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 332 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IFTTT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v88H0V0zm160 0h-48v28h20v60h28V28h20V0h-20zm76 0h-48v28h20v60h28V28h20V0h-20zm76 0h-48v28h20v60h28V28h20V0h-20zM104 28V0H40v88h28V64h24V36H68v-8h36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIftt);
export default __webpack_public_path__ + "static/media/iftt.0afc8aed7bd8e2dca319d986feba3664.svg";
export { ForwardRef as ReactComponent };